import React from "react";

import { RenderLeafProps } from "slate-react/dist/components/editable";

import { addSchemeToUrlIfEmpty } from "@mapmycustomers/shared";
import parsePhoneNumber from "@mapmycustomers/shared/util/phone/parsePhoneNumber";

import TextDecoration from "../../../type/slate/TextDecoration";
import TextSize from "../../../type/slate/TextSize";
import TextType from "../../../type/slate/TextType";
import styles from "../EmailBody.module.scss";

interface LeafProps extends RenderLeafProps {}

const Leaf = ({ attributes, children, leaf }: LeafProps) => {
  const style = {
    ...(leaf.color ? { color: leaf.color } : {}),
  };

  if (leaf.size === TextSize.LARGE) {
    children = <span className={styles.sizeLarge}>{children}</span>;
  } else if (leaf.size === TextSize.SMALL) {
    children = <span className={styles.sizeSmall}>{children}</span>;
  } else {
    children = <span className={styles.sizeMedium}>{children}</span>;
  }

  if (leaf.decoration === TextDecoration.URL) {
    const href = addSchemeToUrlIfEmpty(leaf.text);
    children = (
      <a
        href={href}
        onClick={() => {
          window.open(href, "_blank");
        }}
      >
        <u>{children}</u>
      </a>
    );
  }

  if (leaf.decoration === TextDecoration.EMAIL) {
    children = (
      <a
        href={`mailto:${leaf.text}`}
        onClick={() => {
          window.location.assign(`mailto:${leaf.text}`);
        }}
        {...attributes}
      >
        <u>{children}</u>
      </a>
    );
  }

  if (leaf.decoration === TextDecoration.PHONE) {
    const parsedPhoneNumber = parsePhoneNumber(leaf.text);
    const phoneNumberLink = parsedPhoneNumber?.link;
    if (phoneNumberLink) {
      children = (
        <a
          href={phoneNumberLink!}
          onClick={() => {
            window.location.href = phoneNumberLink!;
          }}
          {...attributes}
        >
          <u>{children}</u>
        </a>
      );
    }
  }

  if (leaf[TextType.BOLD]) {
    children = <strong style={style}>{children}</strong>;
  }

  if (leaf[TextType.ITALIC]) {
    children = <em style={style}>{children}</em>;
  }

  if (leaf[TextType.UNDERLINE]) {
    children = <u style={style}>{children}</u>;
  }

  if (leaf[TextType.STRIKE]) {
    children = <span style={{ ...style, textDecoration: "line-through" }}>{children}</span>;
  }

  return (
    <span style={style} {...attributes}>
      {children}
    </span>
  );
};

export default Leaf;
